import type { ClipboardPayload } from 'helpers/tableClipboard.helper/tableClipboard.helper.types'
import { groupElplanDraftByHour, toStoredSlotEdits } from './draft'
import type { ElplanDraft, ElplanSlot, ElplanSlotEdit, ElplanSlotUnit } from './ElplanEditor.types'

export function mapElplanPastePayload(
  payload: ClipboardPayload,
  selectedSlots: readonly ElplanSlot[],
  valueTargets: readonly ElplanSlot[],
  mode: ElplanSlotUnit,
  draft: ElplanDraft
): ElplanSlotEdit[] | null {
  if (payload.some((row) => row.length > 1)) {
    return null
  }

  const texts = payload.map(([text]) => text.trim())
  if (texts.length === 1) {
    const [text] = texts
    return text === '' ? [] : valueTargets.flatMap((slot) => toStoredSlotEdits(slot, text, draft))
  }

  const steps = getModeSteps(mode, draft)
  const selectedStarts = new Set(selectedSlots.map(({ start }) => start))
  const fromIndex = steps.findIndex((start) => selectedStarts.has(start))
  if (fromIndex < 0) {
    return []
  }

  return steps
    .slice(fromIndex, fromIndex + texts.length)
    .flatMap((start, rowIndex) => toStoredSlotEdits({ unit: mode, start }, texts[rowIndex], draft))
}

function getModeSteps(mode: ElplanSlotUnit, draft: ElplanDraft): readonly ISODateTime[] {
  return mode === 'quarter' ? draft.slotStarts : groupElplanDraftByHour(draft).map(({ hourStart }) => hourStart)
}
